import { conversionTrackingConfig } from "./config";
import type { LeadConversionAdapter } from "./contracts";
import { ga4LeadAdapter } from "./providers/ga4";
import { metaCapiLeadAdapter } from "./providers/meta-capi";
import { metaPixelLeadAdapter } from "./providers/meta-pixel";
import { openAiPixelLeadAdapter } from "./providers/openai-pixel";

export function getEnabledLeadAdapters(): LeadConversionAdapter[] {
  return [
    conversionTrackingConfig.ga4Enabled ? ga4LeadAdapter : undefined,
    conversionTrackingConfig.metaPixelEnabled ? metaPixelLeadAdapter : undefined,
    conversionTrackingConfig.metaCapiEnabled ? metaCapiLeadAdapter : undefined,
    conversionTrackingConfig.openaiPixelEnabled ? openAiPixelLeadAdapter : undefined,
  ].filter((adapter): adapter is LeadConversionAdapter => adapter !== undefined);
}
